import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import { history } from 'Store';
import { userStageSelector } from 'Store/modules/validations/selectors';
import { searchSelector } from 'Store/modules/router/selectors';
import { useFlags } from 'Hooks/useFlags';
import { PreviousYearStatus } from 'Containers/PreviousYears/types';
import { useGetUserWithPreFiling } from 'Containers/Dashboard/hooks';
import { routes } from 'Constants/routes';
import { plansNameMapping } from 'Constants/plans';
import { stages } from 'Constants/stages';
import { FlagsKey } from 'Types/common';
import TransitionLoader from './components/TransitionLoader';
import { useFetchGetResult, useFetchGetUserComplex, useGetResultExtraInformation } from './hooks';
import View from './view';

const Result = (): JSX.Element => {
  const { isLoading, data } = useFetchGetResult();
  const resultExtraInformation = useGetResultExtraInformation();
  const { data: userComplex, isLoading: loadingComplex } = useFetchGetUserComplex();
  const planes = useSelector(searchSelector);
  const toFiling = useSelector(searchSelector);
  const userStage = useSelector(userStageSelector);
  const isUserWithPreFiling = useGetUserWithPreFiling(userStage, data);
  const { enabled: activate } = useFlags(FlagsKey.FILE_NOW_PAY_LATER);
  const { plans } = queryString.parse(planes);
  const { filing } = queryString.parse(toFiling);

  useEffect(() => {
    if ((userStage && userStage !== stages.RESULT) || isUserWithPreFiling) {
      history.push(routes.DASHBOARD);
    }
  }, [userStage, isUserWithPreFiling]);

  useEffect(() => {
    if (data && activate && filing && plans) {
      history.replace(`${routes.FILING}?subscription=${plansNameMapping(plans?.toString())}`, {
        taxReturnType: data?.taxReturnType,
        taxReturnResult: data?.taxReturnResult,
      });
    }
  }, [plans, data]);

  if (
    isLoading ||
    !data ||
    resultExtraInformation.some(item => item.isLoading || item.isFetching) ||
    loadingComplex
  ) {
    return <TransitionLoader />;
  }
  const previousYearApprove = resultExtraInformation[0]?.data?.stage === PreviousYearStatus.READY;
  return (
    <View
      data={data}
      previousYears={{
        approve: previousYearApprove,
        returnType: resultExtraInformation[0]?.data?.refundStatusType,
      }}
      userProfile={userComplex}
    />
  );
};

export default Result;
